import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const cartUrl = 'https://competirsinmiedo.com/cart/add?id=45092891263029&quantity=1';
  return <section className="py-16 md:py-24 bg-brand-green relative overflow-hidden text-center" data-id="element-44">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1518605368461-1e1e111e1ebc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-45"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-brand-green-dark to-transparent opacity-80" data-id="element-46"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-48">
          <h2 className="text-4xl md:text-5xl font-heading text-white mb-6 leading-tight" data-id="element-49">
            Ayuda a tu hijo a recuperar su confianza, disfrutar otra vez del
            fútbol y competir con más fortaleza mental.
          </h2>

          <p className="text-xl text-brand-amber font-medium mb-10" data-id="element-50">
            Accede ahora a Competir sin Miedo.
          </p>

          <a href={cartUrl} onClick={trackAddToCart} className="inline-flex justify-center items-center px-10 py-5 text-xl font-bold text-white bg-brand-amber hover:bg-brand-amber-light rounded-xl shadow-2xl hover:shadow-glow transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto" data-id="element-51">
            Quiero Acceder Ahora →
          </a>

          <div className="mt-8 flex items-center justify-center text-white/80 text-sm gap-2" data-id="element-52">
            <ShieldCheckIcon className="w-5 h-5 text-brand-amber" data-id="element-53" />
            <span data-id="element-54">Garantía de satisfacción incluida. Pago 100% seguro.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}